import React from 'react';
import { X } from 'lucide-react';
export function PainAgitation() {
  const painPoints = ['Te despiertas cansada aunque hayas dormido 8 horas', 'Tu vientre aparece hinchado antes de las 10 de la mañana', 'Tienes la mente lenta, como entre algodones', 'Has probado dietas, pastillas, batidos y nada funciona de verdad', 'Sientes que tu cuerpo ya no responde como antes', 'A veces te miras al espejo y no reconoces a la mujer que ves', 'Los médicos te dicen que "todo está bien" pero tú sabes que no', 'Cada semana empiezas con fuerza y a mitad de mes te derrumbas'];
  return <section className="flex flex-col" data-id="element-256">
      {/* Block A */}
      <div className="bg-brand-cream py-16 px-4 sm:px-6 lg:px-8" data-id="element-257">
        <div className="max-w-3xl mx-auto" data-id="element-258">
          <div data-id="element-259">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-dark text-center mb-10" data-id="element-260">
              Si llevas meses (o años) sintiéndote así...
            </h2>

            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-brand-gold/20 mb-8" data-id="element-261">
              <ul className="space-y-4" data-id="element-262">
                {painPoints.map((point, index) => <li key={index} className="flex items-start" data-id="element-263">
                    <div className="flex-shrink-0 mt-1" data-id="element-264">
                      <X className="w-5 h-5 text-brand-red font-bold" strokeWidth={3} data-id="element-265" />
                    </div>
                    <span className="ml-3 text-lg text-brand-dark" data-id="element-266">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>

            <p className="text-center text-lg sm:text-xl font-serif italic text-brand-dark font-medium" data-id="element-267">
              "No estás exagerando. No estás loca.
              <br className="hidden sm:block" data-id="element-268" />
              Tu cuerpo está mandando una señal de socorro —
              <br className="hidden sm:block" data-id="element-269" />y nadie te ha dado las
              herramientas para responder."
            </p>
          </div>
        </div>
      </div>

      {/* Separator Quote */}
      <div className="bg-brand-dark text-brand-gold py-8 px-4 text-center" data-id="element-270">
        <p className="text-xl sm:text-2xl font-serif italic max-w-4xl mx-auto" data-id="element-271">
          "Tu cuerpo no está roto. Está esperando las instrucciones correctas."
        </p>
      </div>

      {/* Block B */}
      <div className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-272">
        <div className="max-w-3xl mx-auto" data-id="element-273">
          <div data-id="element-274">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-dark mb-8" data-id="element-275">
              Lo que nadie te ha dicho sobre por qué no mejoras
            </h2>

            <div className="prose prose-lg max-w-none text-brand-dark font-serif leading-relaxed space-y-6 text-[17px] sm:text-[18px]" data-id="element-276">
              <p data-id="element-277">
                Hay algo que los médicos no te cuentan en consulta. No porque lo
                oculten. Sino porque el sistema no está diseñado para
                explicarlo.
              </p>
              <p data-id="element-278">
                Tu cuerpo, después de los 30 — y especialmente tras los 35 —
                entra en lo que los investigadores llaman{' '}
                <strong data-id="element-279">'inflamación silenciosa'</strong>.
              </p>
              <p data-id="element-280">No duele. No sangra. No sale en ninguna analítica normal.</p>
              <p data-id="element-281">
                Pero está ahí. Todos los días. Saboteando tu energía, deformando
                tu vientre, nublando tu cabeza y haciéndote sentir que la
                versión anterior de ti misma se ha ido para siempre.
              </p>
              <p data-id="element-282">
                Y lo peor: cada dieta que haces, cada producto que pruebas, cada
                esfuerzo que haces... alimenta esa inflamación en lugar de
                apagarla.
              </p>
              <p className="text-xl font-bold text-brand-red mt-8" data-id="element-283">
                No es tu fuerza de voluntad.
                <br data-id="element-284" />
                No es tu metabolismo.
              </p>
              <p className="text-2xl font-bold text-brand-dark" data-id="element-285">
                Es tu biología. En modo emergencia.
              </p>
              <p className="text-xl font-medium text-brand-gold bg-brand-dark inline-block px-4 py-2 mt-4 rounded" data-id="element-286">
                Y tiene un protocolo de salida.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}